module.exports = __webpack_public_path__ + "static/img/metinew1.a9a00073.png";